<template>
    <span>
        <div @click.stop="showDialog = true" class="button button_clear">{{ button }}</div>
        <portal to="body">
            <reo-dialog
                v-if="showDialog"
                @cancel="showDialog = false"
            >
                <div v-html="content" class="content"/>
            </reo-dialog>
        </portal>
    </span>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import { Portal } from 'portal-vue';
    
export default Vue.extend({
    components: {
        ReoDialog,
        Portal
    },
    props: {
        content: String,
        button: String
    },
    data() {

        return {
            showDialog: false
        };
    
    },
});
</script>

<style lang="less" scoped>
.button{
    color: @b_6;
    display: inline;
}
.content{
    font-size: 16px;
    color: @font_primary;
    padding-top: 16px;
    text-align: center;
}
</style>
